import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import Person from "../Person";
import Remittances from "../Accountings/Remittances";
import Factors from "../Accountings/Factors";
import PracticalTexts from "../PracticalTexts";
import Documents from "../Accountings/Documents";
import TimeSheetHeaders from "../TimeSheetHeaders";
import Orderings from "./Orderings";
import BillOfLadings from "../Commerce/BillOfLadings";
import CustomsClearances from "../Commerce/CustomsClearances";
import InsurancePolicies from "../Commerce/InsurancePolicies";
import FullPrices from "../Commerce/FullPrices";
import WorkFlowStepLogging from "../BPMS/WorkFlowStepLogging";

export default class Ordering extends Base {
	constructor(props) {
		super(props);
		this.state = {
			refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
			caller: props.Caller,
			controllerName: 'ordering',
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			parentId: this.isNull(props.ParentId) ? this.getDefaultGuid() : props.ParentId,
			data: null,
			loading: true,
			sourceId: this.isNull(props.SourceId) ? 0 : props.SourceId,
			type: props.Type,
			initPerson: this.isNull(props.InitPerson) ? null : props.InitPerson,
			lastAdjustmentTextId: null,
			uiSettings: this.getUiSettings(),
			baseVersion: this.uuidv4(),
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	async componentDidMount() {
		if (this.state.type === 3)
			this.getUiSettingConfigs({ formName: 'ordering_type3' });

		this.addKeyDown();

		await this.getTranslates({ component: 'ordering' });

		this.httpPost("api/v1/ordering/get", {
			id: this.state.id,
			type: this.state.type,
			parentId: this.state.parentId
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;
					if (this.state.id === this.getDefaultGuid()) {
						if (!this.isNull(this.state.initPerson)) {
							this.state.data.record.personId = this.state.initPerson.id;
							this.state.data.record.personName = this.state.initPerson.name;
						}
					}
					this.state.loading = false;
					this.updateFormula();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	selectTextAddjustment(type, id) {
		this.state.lastAdjustmentTextId = id;
		this.removeKeyDown();
		this.showComponents({
			component: (
				<PracticalTexts
					Caller={this}
					Type={type}
					OnSelect="onSelectTextAddjustment"
				/>
			),
		});

	}
	onSelectTextAddjustment(e) {
		this.state.data.record.adjustments.forEach(adj => {
			if (adj.id === this.state.lastAdjustmentTextId) {
				adj.description = e.text;
			}
		});
		this.setState({ data: this.state.data });
	}
	getCaption() {
		if (this.state.data.record.type === 1) return "سفارش";
		if (this.state.data.record.type === 2) return "پیش فاکتور";
		if (this.state.data.record.type === 3) return "سفارش تولید";
		if (this.state.data.record.type === 4) return 'سفارش خرید';
		if (this.state.data.record.type === 5) return 'برآورد سفارش';
		if (this.state.data.record.type === 6) return 'پردازش تولید';
		if (this.state.data.record.type === 7) return 'تولید محصولی-مرحله ای';
		if (this.state.data.record.type === 8) return 'سفارش خارجی';
		return "";
	}
	save(e, status) {
		e.preventDefault();
		if (this.isBlank(this.state.data.record.number)) this.state.data.record.number = 0;
		if (this.isBlank(this.state.data.record.serial)) this.state.data.record.serial = 0;
		if (this.isBlank(this.state.data.record.driverCost)) this.state.data.record.driverCost = 0;
		if (this.isBlank(this.state.data.record.currencyRate)) this.state.data.record.currencyRate = 0;
		if (this.isBlank(this.state.data.record.wage)) this.state.data.record.wage = 0;

		var costs = [];

		this.state.data.record.costs.forEach(i => {
			var clone = Object.assign({}, i);
			clone.date = this.convertMomentToDb(clone.date);
			costs.push(clone);
		});

		this.httpPost("api/v1/ordering/save", {
			id: this.state.id,
			currencyId: this.state.data.record.currencyId,
			currencyRate: this.state.data.record.currencyRate,
			wage: this.state.data.record.wage,
			sharedMethod: this.state.data.record.sharedMethod,
			supplierId: this.state.data.record.supplierId,
			type2Id: this.state.data.record.type2Id,
			tafsilAccountId: this.state.data.record.tafsilAccountId,
			title: this.state.data.record.title,
			marketerId: this.state.data.record.marketerId,
			address: this.state.data.record.address,
			adjustments: this.state.data.record.adjustments,
			analizes: this.state.data.record.analizes,
			type: this.state.data.record.type,
			organizationId: this.state.data.global.company.id,
			personId: this.state.data.record.personId,
			productionLines: this.state.data.record.productionLines,
			organWorkingGroups: this.state.data.record.organWorkingGroups,
			parentId: this.state.data.record.parentId,
			number: this.state.data.record.number,
			serial: this.state.data.record.serial,
			driverId: this.state.data.record.driverId,
			driverCost: this.state.data.record.driverCost,
			date: this.convertMomentToDb(this.state.data.record.date),
			description: this.state.data.record.description,
			rejectDescription: this.state.data.record.rejectDescription,
			sourceId: this.state.sourceId,
			locationLong: this.state.data.record.locationLong,
			locationLat: this.state.data.record.locationLat,
			status: status,
			items: this.state.data.record.items,
			costs: costs,
			stuffId: this.state.data.record.stuffId,
			unitId: this.state.data.record.unitId,
			amount: this.state.data.record.amount,
			estimatedTotalTimeSheet: this.state.data.record.estimatedTotalTimeSheet,
			startDate: this.convertMomentToDb(this.state.data.record.startDate),

			discount: this.state.data.record.discount,
			tprdis: this.state.data.record.tprdis,
			tdis: this.state.data.record.tdis,
			tvam: this.state.data.record.tvam,
			total: this.state.data.record.total,

			estimatedOverhead: this.state.data.record.estimatedOverhead,
			overheadRate: this.state.data.record.overheadRate,
			overheadBase: this.state.data.record.overheadBase,
			estimatedSalary: this.state.data.record.estimatedSalary,
			salaryRate: this.state.data.record.salaryRate,
			salaryBase: this.state.data.record.salaryBase,

			formulaItems: this.state.data.record.formulaItems,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage(this.getCaption() + " با موفقیت ذخیره شد");
					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	getBlankRow(defaultIndex = null) {
		return {
			id: this.uuidv4(),
			order: (defaultIndex == null ? this.state.data.record.items.length + 1 : defaultIndex),
			stuffId: this.defaultGuid(),
			stuffName: '',
			stuffType: 1,
			count: 0,
			description: '',
			warehouseId: this.defaultGuid(),
			warehouseName: '',
			productionLineId: this.defaultGuid(),
			productionLineName: '',
			unitId: this.defaultGuid(),
			unitName: '',
			discount: 0,
			price: 0,
			prdis: 0,
			adis: 0,
			total: 0,
			tax: 0,
			taxRate: 0,
			modulusCount: 0,
			modulusUnitId: this.getDefaultGuid(),
			modulusUnitName: '',
			modulusUnitRate: 0
		};
	}
	addBlankRow() {
		this.state.data.record.items.push(this.getBlankRow());
	}
	removeRow(id) {
		var temp = [];
		var index = 1;
		this.state.data.record.items.sort((a, b) => a.order - b.order).forEach(r => {
			if (r.id != id) {
				temp.push(r);
				temp[temp.length - 1].order = index;
				index++;
			}
		});
		this.state.data.record.items = temp;
		this.updateFormula();
	}
	copyRow(id) {
		var clone = null;
		this.state.data.record.items.forEach(i => {
			if (i.id === id) {
				clone = Object.assign({}, i);
			}
		});
		clone.id = this.uuidv4();
		var startIndex = clone.order;
		for (var i = 0; i < this.state.data.record.items.length; i++) {
			if (this.state.data.record.items[i].order > startIndex) this.state.data.record.items[i].order++;
		}
		clone.order++;
		this.state.data.record.items.push(clone);
		this.updateFormula();
	}
	upIndex(id) {
		var idIndex = -1;
		this.state.data.record.items.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex > 0) {
			var ii = this.state.data.record.items[idIndex].order;
			this.state.data.record.items[idIndex].order = ii - 1;
			this.state.data.record.items[idIndex - 1].order = ii;
			this.setState({ data: this.state.data });
		}
	}
	downIndex(id) {
		var idIndex = -1;
		this.state.data.record.items.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex < this.state.data.record.items.length - 1) {
			var ii = this.state.data.record.items[idIndex].order;
			this.state.data.record.items[idIndex].order = ii + 1;
			this.state.data.record.items[idIndex + 1].order = ii;
			this.setState({ data: this.state.data });
		}
	}
	updateModulusCount(i) {
		this.state.data.record.items[i]['modulusCount'] = (this.state.data.record.items[i]['count'] * this.state.data.record.items[i]['modulusUnitRate']);
	}
	setBodyValue(id, field, value) {
		for (var i = 0; i < this.state.data.record.items.length; i++) {
			if (this.state.data.record.items[i].id === id) {
				if (field == 'stuffId' || field == 'warehouseId' || field == 'productionLineId' || field == 'unitId' || field == 'price') {
					if (field == 'stuffId') {
						this.state.data.record.items[i][field] = value.value;
						this.state.data.record.items[i]['count'] = 1;
						this.state.data.record.items[i]['unitId'] = value.unitId;
						this.state.data.record.items[i]['modulusUnitId'] = value.modulusUnitId;
						this.state.data.record.items[i]['modulusUnitName'] = value.modulusUnitName;
						this.state.data.record.items[i]['modulusUnitRate'] = value.modulusUnitRate;
						this.state.data.record.items[i]['unitName'] = value.unitName;
						this.state.data.record.items[i]["stuffName"] = value.label;
						this.state.data.record.items[i]["stuffType"] = value.type;
						
						if (this.state.data.record.type === 2) {
							if (this.state.data.global.company.enableTaxInProformaInvoice)
								this.state.data.record.items[i]['taxRate'] = value.taxRate;
							else
								this.state.data.record.items[i]['taxRate'] = 0;
							this.state.data.record.items[i]['price'] = value.price;
						}
						this.updateModulusCount(i);
					}
					if (field == 'warehouseId') {
						this.state.data.record.items[i][field] = value.value;
						this.state.data.record.items[i]["warehouseName"] = value.label;
					}
					if (field == 'productionLineId') {
						this.state.data.record.items[i][field] = value.value;
						this.state.data.record.items[i]["productionLineName"] = value.label;
					}
					if (field == 'unitId') {
						this.state.data.record.items[i][field] = value.value;
						this.state.data.record.items[i]["unitName"] = value.label;
					}
					if (field == 'price') {
						this.state.data.record.items[i][field] = value;
					}
				}
				else {
					this.state.data.record.items[i][field] = value;
				}
				if (field == 'count') {
					this.updateModulusCount(i);
				}
			}
		}
		this.updateFormula();
	}
	updateFormula() {
		var tprdis = 0;
		var tdis = 0;
		var tvam = 0;
		var total = 0;
		var sumAnalize = 0;
		var sumCost = 0;
		var hasBlankRow = false;

		for (var i = 0; i < this.state.data.record.items.length; i++) {
			if (this.state.data.record.items[i].stuffId == this.defaultGuid()) hasBlankRow = true;

			if (this.state.data.record.type === 2 || this.state.data.record.type === 5) {

				this.state.data.record.items[i]['prdis'] = (this.state.data.record.items[i]['count'] * this.state.data.record.items[i]['price']);
				tprdis += this.state.data.record.items[i]['prdis'];

				this.state.data.record.items[i]['adis'] = this.state.data.record.items[i]['prdis'] - this.state.data.record.items[i]['discount'];
				tdis += this.state.data.record.items[i]['discount'];

				if (this.state.data.record.items[i]['taxRate'] > 0)
					this.state.data.record.items[i]['tax'] = this.FixedPointNumber((this.state.data.record.items[i]['adis'] * this.state.data.record.items[i]['taxRate']) / 100, 0);
				else
					this.state.data.record.items[i]['tax'] = 0;
				tvam += this.state.data.record.items[i]['tax'];

				this.state.data.record.items[i]['total'] = this.state.data.record.items[i]['tax'] + this.state.data.record.items[i]['adis'];
				total += this.state.data.record.items[i]['total'];
			}
		}

		var addition = 0;
		var deduction = 0;
		this.state.data.record.adjustments.forEach(adj => {
			if (adj.type === 1) {
				if (adj.percent != 0)
					adj.price = this.FixedPointNumber(parseInt((total * adj.percent) / 100), 0);

				addition += adj.price;
			}
			if (adj.type === 2) {
				if (adj.percent != 0)
					adj.price = this.FixedPointNumber(parseInt((total * adj.percent) / 100), 0);

				deduction += adj.price;
			}
		});

		this.state.data.record.analizes.forEach(an => {
			sumAnalize += an.total;
		});
		this.state.data.record.costs.forEach(an => {
			sumCost += an.total;
		});

		if (this.state.data.record.type === 2) {
			this.state.data.record.tprdis = tprdis;
			this.state.data.record.tdis = tdis;
			this.state.data.record.tvam = tvam;
			this.state.data.record.total = total + (addition - deduction) - this.state.data.record.discount;
		}
		if (this.state.data.record.type === 5) {
			this.state.data.record.total = total + sumAnalize + sumCost + this.state.data.record.estimatedOverhead + this.state.data.record.estimatedSalary;
		}

		if (!hasBlankRow && ((this.state.data.record.type === 7 && this.state.data.record.status === 0) || (this.state.data.record.type !== 7 && this.state.data.record.type !== 6 && this.state.data.record.type !== 3) || (this.state.data.record.type === 3 && this.state.data.global.company.mainBussinessType===3))) this.addBlankRow();

		this.setState({ date: this.state.data });
	}
	setProductionLine(e) {
		this.state.data.record.productionLines = e;
		this.setState({ data: this.state.data });
	}
	setOrganWorkingGroup(e) {
		this.state.data.record.organWorkingGroups = e;
		this.setState({ data: this.state.data });
	}	
	setParent(e) {
		this.state.data.record.parentId = e.value;
		this.state.data.record.parentDescription = e.label;
		this.setState({ data: this.state.data });
	}
	setPerson(e) {
		if (e.value == -1) {
			this.state.data.record.personId = this.defaultGuid();
			this.state.data.record.personName = '';
			this.showComponents({ component: <Person Caller={this} FromAutoComplete={true} /> });
			return;
		}
		this.state.data.record.personId = e.value;
		this.state.data.record.personName = e.label;
		this.setState({ data: this.state.data });
	}
	setDriver(e) {
		if (e.value == -1) {
			this.state.data.record.driverId = this.defaultGuid();
			this.state.data.record.driverName = '';
			this.showComponents({ component: <Person Caller={this} FromAutoComplete={true} /> });
			return;
		}
		this.state.data.record.driverId = e.value;
		this.state.data.record.driverName = e.label;
		this.setState({ data: this.state.data });
	}
	setMarketer(e) {
		if (e.value == -1) {
			this.state.data.record.marketerId = this.defaultGuid();
			this.state.data.record.marketerName = '';
			this.showComponents({ component: <Person Caller={this} FromAutoComplete={true} /> });
			return;
		}
		this.state.data.record.marketerId = e.value;
		this.state.data.record.marketerName = e.label;
		this.setState({ data: this.state.data });
	}
	setType2(e) {
		if (e == null) {
			this.state.data.record.type2Id = null;
			this.state.data.record.type2Name = '';
		}
		else {
			this.state.data.record.type2Id = e.value;
			this.state.data.record.type2Name = e.label;
		}
		this.setState({ data: this.state.data });
	}
	setSupplier(e) {
		if (e == null) {
			this.state.data.record.supplierId = null;
			this.state.data.record.supplierName = '';
		}
		else {
			this.state.data.record.supplierId = e.value;
			this.state.data.record.supplierName = e.label;
		}
		this.setState({ data: this.state.data });
	}
	setTafsilAccount(e) {
		if (e == null) {
			this.state.data.record.tafsilAccountId = null;
			this.state.data.record.tafsilAccountName = '';
		}
		else {
			this.state.data.record.tafsilAccountId = e.value;
			this.state.data.record.tafsilAccountName = e.label;
		}
		this.setState({ data: this.state.data });
	}
	setStuff(e) {
		this.state.data.record.stuffId = e.value;
		this.state.data.record.stuffName = e.label;

		this.state.data.record.items = [];

		this.httpPost("api/v1/stuff/get", {
			id: this.state.data.record.stuffId
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {

					this.state.data.record.unitId = data.record.unitId;
					this.state.data.record.unitName = data.record.unitName;

					data.formulas.forEach(formula => {
						this.addBlankRow();
						var lastId = this.state.data.record.items[this.state.data.record.items.length - 1].id;

						this.setBodyValue(lastId, 'stuffId', {
							value: formula.itemId,
							label: formula.itemName,
							unitId: formula.unitId,
							unitName: formula.unitName,
							modulusUnitId: formula.modulusUnitId,
							modulusUnitName: formula.modulusUnitName,
							modulusUnitRate: formula.modulusUnitRate
						});
						this.setBodyValue(lastId, 'count', formula.count);
					});
				}
				else {
					this.showErorrMessage(data.message);
				}
				this.setState({
					loading: false
				});
			});
	}
	setUnit(e) {
		this.state.data.record.unitId = e.value;
		this.state.data.record.unitName = e.label;
		this.setState({ data: this.state.data });
	}
	getBlankCostRow(defaultIndex = null,type=0) {
		return {
			id: this.uuidv4(),
			order: (defaultIndex == null ? this.state.data.record.costs.length + 1 : defaultIndex),
			count: 0,
			description: '',
			price: 0,
			total: 0,
			date: null,
			stuffId: this.getDefaultGuid(),
			stuffName: '',
			type: type,
		};
	}
	addBlankCostRow(type) {
		this.state.data.record.costs.push(this.getBlankCostRow(null,type));
		this.setState({ data: this.state.data });
	}
	removeCostRow(id) {
		var temp = [];
		var index = 1;
		this.state.data.record.costs.sort((a, b) => a.order - b.order).forEach(r => {
			if (r.id != id) {
				temp.push(r);
				temp[temp.length - 1].order = index;
				index++;
			}
		});
		this.state.data.record.costs = temp;
		this.setState({ date: this.state.data });
	}
	setCostValue(id, field, value) {
		for (var i = 0; i < this.state.data.record.costs.length; i++) {
			if (this.state.data.record.costs[i].id === id) {
				if (field === 'stuffId') {
					this.state.data.record.costs[i][field] = value.value;
					this.state.data.record.costs[i]['stuffName'] = value.label;
				}
				else
					this.state.data.record.costs[i][field] = value;
			}
		}
		this.updateCostFormula();
	}
	updateCostFormula() {
		for (var i = 0; i < this.state.data.record.costs.length; i++) {
			this.state.data.record.costs[i]['total'] = this.FixedPointNumber(parseInt(this.state.data.record.costs[i]['count'] * this.state.data.record.costs[i]['price']), 0);
		}
		this.updateFormula();
	}
	setOverheadBase(e) {
		this.state.data.record.overheadBase = parseInt(e.target.value.replace(/,/g, ''));
		this.state.data.record.estimatedOverhead = this.state.data.record.overheadBase * this.state.data.record.overheadRate;
		this.updateFormula();
	}
	setOverheadRate(e) {
		this.state.data.record.overheadRate = parseInt(e.target.value.replace(/,/g, ''));
		this.state.data.record.estimatedOverhead = this.state.data.record.overheadBase * this.state.data.record.overheadRate;
		this.updateFormula();
	}
	setSalaryBase(e) {
		this.state.data.record.salaryBase = parseInt(e.target.value.replace(/,/g, ''));
		this.state.data.record.estimatedSalary = this.state.data.record.salaryBase * this.state.data.record.salaryRate;
		this.updateFormula();
	}
	setSalaryRate(e) {
		this.state.data.record.salaryRate = parseInt(e.target.value.replace(/,/g, ''));
		this.state.data.record.estimatedSalary = this.state.data.record.salaryBase * this.state.data.record.salaryRate;
		this.updateFormula();
	}
	getBlankAdjustmentRow(defaultIndex = null, type) {
		return {
			id: this.uuidv4(),
			index: (defaultIndex == null ? this.state.data.record.adjustments.length + 1 : defaultIndex),
			description: '',
			type: type,
			price: 0,
			percent: 0,
		};
	}
	addBlankAdjustmentRow(type) {
		this.state.data.record.adjustments.push(this.getBlankAdjustmentRow(null, type));
		this.setState({ data: this.state.data });
	}
	removeAdjustmentRow(id) {
		var temp = [];
		var index = 1;
		this.state.data.record.adjustments.sort((a, b) => a.index - b.index).forEach(r => {
			if (r.id != id) {
				temp.push(r);
				temp[temp.length - 1].index = index;
				index++;
			}
		});
		this.state.data.record.adjustments = temp;
		this.updateFormula();
	}
	copyAdjustmentRow(id) {
		var clone = null;
		this.state.data.record.adjustments.forEach(i => {
			if (i.id === id) {
				clone = Object.assign({}, i);
			}
		});
		clone.id = this.uuidv4();
		var startIndex = clone.index;
		for (var i = 0; i < this.state.data.record.adjustments.length; i++) {
			if (this.state.data.record.adjustments[i].index > startIndex) this.state.data.record.adjustments[i].index++;
		}
		clone.index++;
		this.state.data.record.adjustments.push(clone);
		this.updateFormula();
	}
	upIndexAdjustment(id) {
		var idIndex = -1;
		this.state.data.record.adjustments.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex > 0) {
			var ii = this.state.data.record.adjustments[idIndex].index;
			this.state.data.record.adjustments[idIndex].index = ii - 1;
			this.state.data.record.adjustments[idIndex - 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	downIndexAdjustment(id) {
		var idIndex = -1;
		this.state.data.record.adjustments.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex < this.state.data.record.adjustments.length - 1) {
			var ii = this.state.data.record.adjustments[idIndex].index;
			this.state.data.record.adjustments[idIndex].index = ii + 1;
			this.state.data.record.adjustments[idIndex + 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	setAdjustmentValue(id, field, value) {
		for (var i = 0; i < this.state.data.record.adjustments.length; i++) {
			if (this.state.data.record.adjustments[i].id === id) {
				if (field === 'price' || field === 'percent') {
					if (this.isBlank(value) || isNaN(value)) value = 0;
					if (field === 'price') {
						this.state.data.record.adjustments[i][field] = value;
						this.state.data.record.adjustments[i]['percent'] = 0;
					}
					if (field === 'percent') {
						this.state.data.record.adjustments[i][field] = value;
						this.state.data.record.adjustments[i]['price'] = 0;
					}
				}
				else {
					this.state.data.record.adjustments[i][field] = value;
				}
			}
		}
		this.updateFormula();
	}
	renderAdjustments(type) {
		return <div>
			<table className="table table-bordered acc_grid_row">
				<thead>
					<tr className="active">
						<td style={{ "width": "30px" }}>#</td>
						<td>شرح</td>
						<td style={{ "width": "100px" }}>مبلغ <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span><span className="red">*</span></td>
						<td style={{ "width": "100px" }}>درصد <span style={{ "font-weight": "normal" }} ></span><span className="red">*</span></td>
						<td style={{ "width": "35px" }}></td>
					</tr>
				</thead>
				<tbody>
					{this.state.data.record.adjustments.sort((a, b) => a.index - b.index).map((item, index) =>
						item.type === type && <tr key={item.id}>
							<td>
								<span className="inGridRowNumber">{(index + 1)}</span>
								<div style={{ "font-size": "9pt", "color": "silver" }}>
									{index > 0 && index != this.state.data.record.adjustments.length - 1 && <span onClick={e => this.upIndexAdjustment(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
									{index < this.state.data.record.adjustments.length - 2 && <span onClick={e => this.downIndexAdjustment(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
								</div>
							</td>
							<td style={{ "position": "relative" }}>
								{type === 1 && <a style={{ "position": "absolute", "font-size": "25px", "left": "0", "top": "0" }} onClick={e => this.selectTextAddjustment(9, item.id)} title="درج متن آماده"><em className="icon ni ni-property-add text-primary"></em></a>}
								{type === 2 && <a style={{ "position": "absolute", "font-size": "25px", "left": "0", "top": "0" }} onClick={e => this.selectTextAddjustment(10, item.id)} title="درج متن آماده"><em className="icon ni ni-property-add text-primary"></em></a>}
								<input type="text" className="form-control text-center" defaultValue={item.description} onChange={e => this.setAdjustmentValue(item.id, 'description', e.target.value)} />
							</td>
							<td><NumberFormat value={item.price} onChange={e => this.setAdjustmentValue(item.id, 'price', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>
							<td><NumberFormat value={item.percent} onChange={e => this.setAdjustmentValue(item.id, 'percent', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>
							<td>
								<span title="حذف سطر" onClick={e => this.removeAdjustmentRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
								<span title="کپی سطر" onClick={e => this.copyAdjustmentRow(item.id)} className="fa fa-copy fa-fw close-grid-row"></span>
							</td>
						</tr>
					)}
				</tbody>
			</table>
			<a className="btn btn-primary" onClick={e => this.addBlankAdjustmentRow(type)}>افزودن</a>
		</div>
	}
	getAdjustmentSum(type) {
		var s = 0;
		this.state.data.record.adjustments.forEach(adj => {
			if (adj.type === type) s += adj.price;
		});
		return s;
	}
	setAmount(e) {
		this.state.data.record.amount = e;
		this.setState({ baseVersion: this.uuidv4() });
	}
	getProductionAmount() {
		if (this.isBlank(this.state.data.record.amount)) return 0;
		return this.state.data.record.amount;
	}
	renderAnalize() {
		return <div>
			<table className="table table-bordered acc_grid_row">
				<thead>
					<tr className="active">
						<td style={{ "width": "30px" }}>#</td>
						{1 === 2 && <td>عامل</td>}
						<td>خط تولید</td>
						<td>نیرو</td>
						<td style={{ "width": "100px" }}>فی <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></td>
						<td style={{ "width": "100px" }}>میزان ساعت</td>
						<td style={{ "width": "100px" }}>مبلغ کل <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></td>
						<td style={{ "width": "35px" }}></td>
					</tr>
				</thead>
				<tbody>
					{this.state.data.record.analizes.sort((a, b) => a.index - b.index).map((item, index) =>
						<tr key={item.id}>
							<td>
								<span className="inGridRowNumber">{(index + 1)}</span>
								<div style={{ "font-size": "9pt", "color": "silver" }}>
									{index > 0 && index != this.state.data.record.analizes.length - 1 && <span onClick={e => this.upIndexAnalize(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
									{index < this.state.data.record.analizes.length - 2 && <span onClick={e => this.downIndexAnalize(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
								</div>
							</td>
							{1 === 2 && <td style={{ "position": "relative" }}>
								<SelectAsync
									value={item.stuffId != this.defaultGuid() ? [{ value: item.stuffId, label: item.stuffName }] : null}
									isMulti={false}
									placeholder="انتخاب عامل"
									noOptionsMessage={({ inputValue }) =>
										inputValue ? "نتیجه‌ای یافت نشد" : null
									}
									defaultOptions={[]}
									components={{
										DropdownIndicator: () => null,
										IndicatorSeparator: () => null,
									}}
									loadOptions={(inputValue, callback) => this.loadStuffsOptions(inputValue, callback)}
									onChange={e => this.setAnalizeValue(item.id, 'stuffId', e)}
								/>
							</td>}
							<td style={{ "position": "relative" }}>
								<SelectAsync
									value={item.productionLineId != this.defaultGuid() ? [{ value: item.productionLineId, label: item.productionLineName }] : null}
									isMulti={false}
									placeholder="انتخاب خط تولید"
									noOptionsMessage={({ inputValue }) =>
										inputValue ? "نتیجه‌ای یافت نشد" : null
									}
									defaultOptions={[]}
									components={{
										DropdownIndicator: () => null,
										IndicatorSeparator: () => null,
									}}
									loadOptions={(inputValue, callback) => this.loadProductionLinesOptions(inputValue, callback)}
									onChange={e => this.setAnalizeValue(item.id, 'productionLineId', e)}
								/>
							</td>
							<td style={{ "position": "relative" }}>
								<SelectAsync
									value={item.personId != this.defaultGuid() ? [{ value: item.personId, label: item.personName }] : null}
									isMulti={false}
									placeholder="انتخاب نیرو"
									noOptionsMessage={({ inputValue }) =>
										inputValue ? "نتیجه‌ای یافت نشد" : null
									}
									defaultOptions={[]}
									components={{
										DropdownIndicator: () => null,
										IndicatorSeparator: () => null,
									}}
									loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback,0,3)}
									onChange={e => this.setAnalizeValue(item.id, 'personId', e)}
								/>
							</td>
							<td><NumberFormat value={item.fee} onChange={e => this.setAnalizeValue(item.id, 'fee', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>
							<td><NumberFormat value={item.hour} onChange={e => this.setAnalizeValue(item.id, 'hour', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>
							<td><NumberFormat value={item.total} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>
							<td>
								<span title="حذف سطر" onClick={e => this.removeAnalizeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
								<span title="کپی سطر" onClick={e => this.copyAnalizeRow(item.id)} className="fa fa-copy fa-fw close-grid-row"></span>
							</td>
						</tr>
					)}
				</tbody>
			</table>
			<a className="btn btn-primary" onClick={e => this.addBlankAnalizeRow()}>افزودن</a>
		</div>
	}
	getBlankAnalizeRow(defaultIndex = null) {
		return {
			id: this.uuidv4(),
			index: (defaultIndex == null ? this.state.data.record.analizes.length + 1 : defaultIndex),
			stuffId: this.getDefaultGuid(),
			stuffName: '',
			productionLineId: this.getDefaultGuid(),
			productionLineName: '',
			personId: this.getDefaultGuid(),
			personName: '',
			fee: 0,
			hour: 0,
			total: 0,
			type: 1
		};
	}
	addBlankAnalizeRow() {
		this.state.data.record.analizes.push(this.getBlankAnalizeRow(null));
		this.setState({ data: this.state.data });
	}
	removeAnalizeRow(id) {
		var temp = [];
		var index = 1;
		this.state.data.record.analizes.sort((a, b) => a.index - b.index).forEach(r => {
			if (r.id != id) {
				temp.push(r);
				temp[temp.length - 1].index = index;
				index++;
			}
		});
		this.state.data.record.analizes = temp;
		this.updateFormula();
	}
	copyAnalizeRow(id) {
		var clone = null;
		this.state.data.record.analizes.forEach(i => {
			if (i.id === id) {
				clone = Object.assign({}, i);
			}
		});
		clone.id = this.uuidv4();
		var startIndex = clone.index;
		for (var i = 0; i < this.state.data.record.analizes.length; i++) {
			if (this.state.data.record.analizes[i].index > startIndex) this.state.data.record.analizes[i].index++;
		}
		clone.index++;
		this.state.data.record.analizes.push(clone);
		this.updateFormula();
	}
	upIndexAnalize(id) {
		var idIndex = -1;
		this.state.data.record.analizes.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex > 0) {
			var ii = this.state.data.record.analizes[idIndex].index;
			this.state.data.record.analizes[idIndex].index = ii - 1;
			this.state.data.record.analizes[idIndex - 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	downIndexAnalize(id) {
		var idIndex = -1;
		this.state.data.record.analizes.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex < this.state.data.record.analizes.length - 1) {
			var ii = this.state.data.record.analizes[idIndex].index;
			this.state.data.record.analizes[idIndex].index = ii + 1;
			this.state.data.record.analizes[idIndex + 1].index = ii;
			this.setState({ data: this.state.data });
		}
	}
	async setAnalizeValue(id, field, value) {
		for (var i = 0; i < this.state.data.record.analizes.length; i++) {
			if (this.state.data.record.analizes[i].id === id) {
				if (field === 'fee' || field === 'hour' || field == 'stuffId' || field == 'personId' || field == 'productionLineId') {
					if (field === 'stuffId') {
						this.state.data.record.analizes[i][field] = value.value;
						this.state.data.record.analizes[i]['stuffName'] = value.label;
					}
					if (field === 'personId') {
						this.state.data.record.analizes[i][field] = value.value;
						this.state.data.record.analizes[i]['personName'] = value.label;
					}
					if (field === 'productionLineId') {
						this.state.data.record.analizes[i][field] = value.value;
						this.state.data.record.analizes[i]['productionLineName'] = value.label;
					}
					if (this.state.data.record.type === 6 && (field === 'personId' || field === 'productionLineId')) {

						this.state.data.record.analizes[i]['hour'] = 0;

						var apiResualt = await this.httpPost("api/v1/timesheet/sum/", {
							personId: this.state.data.record.analizes[i]['personId'],
							productionLineId: this.state.data.record.analizes[i]['productionLineId'],
							orderingId: this.state.data.record.id,
						});
						if (apiResualt.status === -1) window.location.href = "/login";
						if (apiResualt.status === 1) {
							this.state.data.record.analizes[i]['hour'] = this.FixedPointNumber((apiResualt.sum) / 60, 2);
						}

						this.state.data.record.analizes[i]['total'] = this.FixedPointNumber(this.state.data.record.analizes[i]['fee'] * this.state.data.record.analizes[i]['hour'], 0);
					}
					if (field === 'fee' || field === 'hour') {
						if (this.isBlank(value) || isNaN(value)) value = 0;
						this.state.data.record.analizes[i][field] = value;
						this.state.data.record.analizes[i]['total'] = this.FixedPointNumber(this.state.data.record.analizes[i]['fee'] * this.state.data.record.analizes[i]['hour'], 0);
					}
				}
				else {
					this.state.data.record.analizes[i][field] = value;
				}
			}
		}
		this.updateFormula();
	}
	setFormulaItemsValue(id, field, value) {
		for (var i = 0; i < this.state.data.record.formulaItems.length; i++) {
			if (this.state.data.record.formulaItems[i].id === id) {
				this.state.data.record.formulaItems[i][field] = value;
				this.state.data.record.formulaItems[i]['total'] = this.FixedPointNumber(this.state.data.record.formulaItems[i]['count'] * this.state.data.record.formulaItems[i]['price'], 0);
			}
		}
		this.setState({ date: this.state.data });
	}
	renderForumalItems(type) {
		return <table className="table table-bordered acc_grid_row">
			<thead>
				<tr className="active">
					<td style={{ "width": "30px" }}>#</td>
					<td>ماده اولیه</td>
					<td style={{ "width": "80px" }}><span>تعداد/مقدار</span></td>
					<td>واحد اصلی</td>
					{this.state.data.global.company.stuffSubUnitEnable === 2 && <td style={{ "width": "80px" }}><span>تعداد/مقدار فرعی</span></td>}
					{this.state.data.global.company.stuffSubUnitEnable === 2 && <td>واحد فرعی</td>}
					{type === 1 && <td>ماده تولید شده</td>}
					{type === 1 && <th>فی</th>}
					{type === 1 && <th>قیمت کل</th>}
				</tr>
			</thead>
			<tbody>
				{this.state.data.record.formulaItems.filter(f => f.type === type).sort((a, b) => a.order - b.order).map((item, index) =>
					<tr key={item.id}>
						<td>
							<span className="inGridRowNumber">{(index + 1)}</span>
						</td>
						<td>
							<span>{item.stuffName}</span>
						</td>
						<td>
							<span>{item.count}</span>
						</td>
						<td><span>{item.unitName}</span></td>
						{this.state.data.global.company.stuffSubUnitEnable === 2 &&
							<td>
								<span>{item.modulusCount}</span>
							</td>}
						{this.state.data.global.company.stuffSubUnitEnable === 2 && <td><span>{item.modulusUnitName}</span></td>}
						{type === 1 && <td>{item.secondaryStuffName}</td>}
						{type === 1 && <td>
							<NumberFormat value={item.price} onChange={e => this.setFormulaItemsValue(item.id, 'price', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
						</td>}
						{type === 1 && <td>{item.total}</td>}
					</tr>
				)}
			</tbody>
		</table>
	}
	showCommerceItems() {
		if (this.state.data.record.id === this.getDefaultGuid()) return false;
		if (this.state.data.record.type !== 4 && this.state.data.record.type !== 8) return false;
		return true;
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">{this.getCaption()}</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>
							<div className="row">
								{this.state.data.record.type === 5 && <div className="col-sm-4">
									<div className="form-group">
									<label className="form-label">عنوان</label>
										<input onChange={e => this.state.data.record.title = e.target.value} defaultValue={this.state.data.record.title} autoComplete="off" type="text" className="form-control input-smnumber" maxLength="400" />
									</div>
								</div>}
								{this.state.data.record.type !== 3 && <div className="col-sm-1">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">شماره</label>
										<input onChange={e => this.state.data.record.number = parseInt(e.target.value)} defaultValue={this.state.data.record.number} autocomplete="off" type="text" className="form-control input-smnumber" maxLength="20" />
									</div>
								</div>}
								{this.state.data.record.type === 3 && <div className="col-sm-1">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">ردیف</label>
										<input onChange={e => this.state.data.record.number = parseInt(e.target.value)} defaultValue={this.state.data.record.number} autocomplete="off" type="text" className="form-control input-smnumber" maxLength="20" />
									</div>
								</div>}
								{this.state.data.record.type === 3 &&
									<div className="col-sm-1">
										<div className="form-group">
											<label for="invoiceNumber" className="title1">سریال</label>
											<input onChange={e => this.state.data.record.serial = parseInt(e.target.value)} defaultValue={this.state.data.record.serial} autocomplete="off" type="text" className="form-control input-smnumber" maxlength="20" />
										</div>
									</div>}
								{((this.state.data.record.type !== 7 && this.state.data.record.type !== 4 && this.state.data.record.type !== 8 && this.state.data.record.type !== 3 && this.state.data.record.type !== 6) || (this.state.data.record.type === 3 && this.state.data.global.company.mainBussinessType !== 3)) && <div className="col-sm-3">
									<div className="form-group">
										<label className="title1">مشتری</label>
										<SelectAsync
											value={this.state.data.record.personId != this.defaultGuid() ? [{ value: this.state.data.record.personId, label: this.state.data.record.personName }] : null}
											isMulti={false}
											placeholder="انتخاب مشتری"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1, 1)}
											onChange={e => this.setPerson(e)}
										/>
									</div>
								</div>}
								{this.state.data.record.type === 1 && this.state.data.global.company.mainBussinessType === 3 && <div className="col-sm-2">
									<div className="form-group">
										<label for="invoiceContact" className="title1">راننده<span className="red">*</span></label>
										<SelectAsync
											value={this.state.data.record.driverId != this.defaultGuid() ? [{ value: this.state.data.record.driverId, label: this.state.data.record.driverName }] : null}
											isMulti={false}
											placeholder="انتخاب راننده"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 10)}
											onChange={e => this.setDriver(e)}
										/>
									</div>
								</div>}
								{this.state.data.record.type === 2 && <div className="col-sm-2">
									<div className="form-group">
										<label className="form-label">بازاریاب</label>
										<SelectAsync
											value={this.state.data.record.marketerId === null ? [{ value: this.state.data.record.marketerId, label: this.state.data.record.marketerName }] : null}
											isMulti={false}
											placeholder="انتخاب بازاریاب"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1, 6)}
											onChange={e => this.setMarketer(e)}
										/>
									</div>
								</div>}
								{this.state.data.record.type === 1 && this.state.data.global.company.mainBussinessType === 3 && <div className="col-sm-2">
									<div className="form-group">
										<label for="invoiceContact" className="title1">کرایه</label>
										<input onChange={e => this.state.data.record.driverCost = parseInt(e.target.value)} defaultValue={this.state.data.record.driverCost} autocomplete="off" type="text" className="form-control input-smnumber" maxLength="20" />
									</div>
								</div>}
								{(this.state.data.record.type === 6 || (this.state.data.global.company.mainBussinessType === 3 && this.state.data.record.type === 3)) && <div className="col-sm-2">
									<div className="form-group">
										<label className="title1">خط تولید</label>
										<SelectAsync
											value={this.state.data.record.productionLines}
											isMulti={true}
											placeholder="انتخاب خطوط تولید"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadProductionLinesOptions(inputValue, callback)}
											onChange={e => this.setProductionLine(e)}
										/>
									</div>
								</div>}
								{(this.state.data.record.type === 6) && <div className="col-lg-4">
									<label className="form-label">گروه های کاری</label>
									<div>
										<SelectAsync
											value={this.state.data.record.organWorkingGroups}
											isMulti={true}
											placeholder="انتخاب گروه های کاری"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadOrganWorkingGroupOptions(inputValue, callback)}
											onChange={e => this.setOrganWorkingGroup(e)}
										/>
									</div>
								</div>}
								{this.state.data.record.type === 1 && this.state.data.global.company.mainBussinessType === 3 && <div className="col-sm-3">
									<div className="form-group">
										<label className="title1">سفارش تولید</label>
										<SelectAsync
											value={this.state.data.record.parentId != this.defaultGuid() ? [{ value: this.state.data.record.parentId, label: this.state.data.record.parentDescription }] : null}
											isMulti={false}
											placeholder="انتخاب سفارش"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadOrderingsOptions(inputValue, callback, 3)}
											onChange={e => this.setParent(e)}
										/>
									</div>
								</div>}
								{this.state.data.record.type === 3 && <div className="col-sm-1">
									<div className="form-group">
										<label for="invoiceDate" className="title1">تاریخ شروع</label>
										<DatePicker
											inputReadOnly={true}
											className="form-control input-sm persian-date"
											placeholder={"تاریخ"}
											isGregorian={false}
											showTodayButton={true}
											timePicker={false}
											onChange={(e) => { this.state.data.record.startDate = e }}
											value={this.getFormatedDateForDatePicker(this.state.data.record.startDate)}
										/>
									</div>
								</div>}
								<div className="col-sm-1">
									<div className="form-group">
										{this.state.data.record.type === 1 && <label className="title1">تاریخ<span className="red">*</span></label>}
										{this.state.data.record.type === 2 && <label className="title1">تاریخ<span className="red">*</span></label>}
										{this.state.data.record.type === 3 && <label className="title1">تاریخ سفارش<span className="red">*</span></label>}
										{this.state.data.record.type === 4 && <label className="title1">تاریخ<span className="red">*</span></label>}
										{this.state.data.record.type === 8 && <label className="title1">تاریخ<span className="red">*</span></label>}
										{this.state.data.record.type === 6 && <label className="title1">تاریخ تولید<span className="red">*</span></label>}
										{this.state.data.record.type === 5 && <label className="title1">تاریخ</label>}
										{this.state.data.record.type === 7 && <label className="title1">تاریخ تولید</label>}
										<DatePicker
											inputReadOnly={true}
											className="form-control input-sm persian-date"
											placeholder={"تاریخ"}
											isGregorian={false}
											showTodayButton={true}
											timePicker={false}
											onChange={(e) => { this.state.data.record.date = e }}
											value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
										/>
									</div>
								</div>
								{(this.state.data.record.type === 3 || this.state.data.record.type === 6) && <div className="col-sm-3">
									<div className="form-group">
										<label className="title1">محصول نهایی<span className="red">*</span></label>
										{this.state.data.record.type !== 6 && this.state.data.record.status === 0 && <SelectAsync
											value={this.state.data.record.stuffId != this.defaultGuid() ? [{ value: this.state.data.record.stuffId, label: this.state.data.record.stuffName }] : null}
											isMulti={false}
											placeholder="انتخاب محصول"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadStuffsOptions(inputValue, callback, 3)}
											onChange={e => this.setStuff(e)}
										/>}
										{(this.state.data.record.type === 6 || (this.state.data.record.type === 3 && this.state.data.record.status !== 0)) && <span>{this.state.data.record.stuffName}</span>}
									</div>
								</div>}
								{(this.state.data.record.type === 3 || this.state.data.record.type === 6) && <div className="col-sm-1">
									<div className="form-group">
										<label className="title1">تعداد<span className="red">*</span></label>
										{(this.state.data.record.type === 6 || (this.state.data.record.type === 3 && this.state.data.record.status === 0)) && <NumberFormat value={this.state.data.record.amount} onChange={e => this.setAmount(parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />}
										{(this.state.data.record.type === 3 && this.state.data.record.status !== 0) && <span>{this.state.data.record.amount}</span>}
									</div>
								</div>}
								{(this.state.data.record.type === 3 || this.state.data.record.type === 6) && <div className="col-sm-1">
									<div className="form-group">
										<label className="title1">واحد</label>
										<span>{this.state.data.record.unitName}</span>
										{/*{this.state.data.record.type !== 6 && this.state.data.record.status === 0 && <SelectAsync*/}
										{/*	value={this.state.data.record.unitId != this.defaultGuid() ? [{ value: this.state.data.record.unitId, label: this.state.data.record.unitName }] : null}*/}
										{/*	isMulti={false}*/}
										{/*	placeholder="واحد"*/}
										{/*	noOptionsMessage={({ inputValue }) =>*/}
										{/*		inputValue ? "نتیجه‌ای یافت نشد" : null*/}
										{/*	}*/}
										{/*	defaultOptions={[]}*/}
										{/*	components={{*/}
										{/*		DropdownIndicator: () => null,*/}
										{/*		IndicatorSeparator: () => null,*/}
										{/*	}}*/}
										{/*	loadOptions={(inputValue, callback) => this.loadUnitsOptions(inputValue, callback)}*/}
										{/*	onChange={e => this.setUnit(e)}*/}
										{/*/>}*/}
										{/*{(this.state.data.record.type === 6 || (this.state.data.record.type === 3 && this.state.data.record.status !== 0)) && <span>{this.state.data.record.unitName}</span>}*/}
									</div>
								</div>}
								{this.state.data.record.type === 5 && <div className="col-sm-1">
									<div className="form-group">
										<label className="title1">برآورد زمان انجام</label>
										<div>
											<NumberFormat value={this.state.data.record.estimatedTotalTimeSheet} onChange={e => this.state.data.record.estimatedTotalTimeSheet = parseInt(e.target.value.replace(/,/g, ''))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
										</div>
									</div>
								</div>}
								{this.state.data.record.type === 3 && this.state.data.global.company.mainBussinessType !== 3 && <div className="col-sm-2">
									<div className="form-group">
										<label className="title1">برآورد سفارش</label>
										<SelectAsync
											value={this.state.data.record.parentId != this.defaultGuid() ? [{ value: this.state.data.record.parentId, label: this.state.data.record.parentDescription }] : null}
											isMulti={false}
											placeholder="انتخاب برآورد سفارش"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadOrderingsOptions(inputValue, callback, 5)}
											onChange={e => this.setParent(e)}
										/>
									</div>
								</div>}

								{this.state.data.record.type === 5 && <div className="col-sm-2">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">مبلغ برآورد</label>
										<NumberFormat value={this.state.data.record.total} disabled={true} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
									</div>
								</div>}

								{(this.state.data.record.type === 8 || this.state.data.record.type === 4) && <div className="col-sm-2">
									<div className="form-group">
										<label className="form-label">نوع قرارداد خرید</label>
										<SelectAsync
											value={this.state.data.record.type2Id !== null ? [{ value: this.state.data.record.type2Id, label: this.state.data.record.type2Name }] : null}
											isMulti={false}
											placeholder="جستجو"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadConstantsOptions(inputValue, callback, 13)}
											onChange={e => this.setType2(e)}
										/>
									</div>
								</div>}
								{(this.state.data.record.type === 8 || this.state.data.record.type === 4) && <div className="col-sm-1">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">ارز</label>
										<select defaultValue={this.state.data.record.currencyId} onChange={e => this.state.data.record.currencyId = e.target.value} className='form-control text-center ltr'>
											<option value="">انتخاب</option>
											{this.state.data.global.currencies.map(cur => <option value={cur.value}>{cur.label}</option>)}
										</select>
									</div>
								</div>}
								{(this.state.data.record.type === 8 || this.state.data.record.type === 4) && <div className="col-sm-1">
									<div className="form-group">
										<label className="title1">روش تسهیم</label>
										<select onChange={(e) => this.state.data.record.sharedMethod = parseInt(e.target.value)} defaultValue={this.state.data.record.sharedMethod} className="form-control">
											<option value="0">قیمتی</option>
											<option value="1">وزنی</option>
											<option value="2">تعدادی</option>
											{/*<option value="3">دستی</option>*/}
											<option value="4">نسبت مساوی</option>
										</select>
									</div>
								</div>}								
								{(this.state.data.record.type === 8 || this.state.data.record.type === 4) && <div className="col-sm-2">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">کارمزد ثبت سفارش</label>
										<NumberFormat value={this.state.data.record.wage} onChange={e => this.state.data.record.wage = parseFloat(e.target.value.replace(/,/g, ''))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
									</div>
								</div>}
								{(this.state.data.record.type === 8 || this.state.data.record.type === 4) && <div className="col-sm-1">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">نرخ ارز</label>
										<NumberFormat value={this.state.data.record.currencyRate} onChange={e => this.state.data.record.currencyRate = parseFloat(e.target.value.replace(/,/g, ''))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
									</div>
								</div>}
								{(this.state.data.record.type === 8 || this.state.data.record.type === 4) && <div className="col-sm-2">
									<div className="form-group">
										<label className="form-label">تامین کننده</label>
										<SelectAsync
											value={this.state.data.record.supplierId !== null ? [{ value: this.state.data.record.supplierId, label: this.state.data.record.supplierName }] : null}
											isMulti={false}
											placeholder="جستجو"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1, 2)}
											onChange={e => this.setSupplier(e)}
										/>
									</div>
								</div>}
								{(this.state.data.record.type === 8 || this.state.data.record.type === 4) && <div className="col-sm-2">
									<div className="form-group">
										<label className="form-label">تفصیل</label>
										<SelectAsync
											value={(this.state.data.record.tafsilAccountId === null || this.state.data.record.tafsilAccountId === this.getDefaultGuid()) ? null : [{ value: this.state.data.record.tafsilAccountId, label: this.state.data.record.tafsilAccountName }]}
											isMulti={false}
											placeholder="جستجو"
											noOptionsMessage={({ inputValue }) =>
												inputValue ? "نتیجه‌ای یافت نشد" : null
											}
											defaultOptions={[]}
											components={{
												DropdownIndicator: () => null,
												IndicatorSeparator: () => null,
											}}
											loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback,4)}
											onChange={e => this.setTafsilAccount(e)}
										/>
									</div>
								</div>}
							</div>
							<div className="row mr-b-20">
								<div className="col-md-12">
									<label className="title1">توضیحات</label>
									<input onChange={e => this.state.data.record.description = e.target.value} defaultValue={this.state.data.record.description} autocomplete="off" type="text" className="form-control input-sm ng-valid" style={{ "width": "100%" }} maxlength="150" />
								</div>
							</div>

							{((this.state.data.global.company.mainBussinessType === 3 && this.state.data.record.status !== 0 && this.state.data.record.type === 3) || this.state.data.record.type !== 3) && <ul className="nav nav-tabs mt-n3">
								<li className="nav-item">
									<a className="nav-link active" data-bs-toggle="tab" href="#base"><em className="icon ni ni-info"></em>
										{((this.state.data.global.company.mainBussinessType === 3 && this.state.data.record.status !== 0 && this.state.data.record.type === 3) || this.state.data.record.type === 6 || this.state.data.record.type === 5) && <span>مواد اولیه</span>}
										{((this.state.data.global.company.mainBussinessType === 3 && this.state.data.record.type !== 3) && this.state.data.record.type !== 6 && this.state.data.record.type !== 5 && this.state.data.record.type !== 7) && <span>اقلام</span>}
										{(this.state.data.record.type === 7) && <span>تولیدات انجام یافته</span>}
									</a>
								</li>
								{(this.state.data.record.type === 5 || (this.state.data.record.type === 6 && this.state.data.record.status === 0 && this.state.data.global.company.mainBussinessType !== 3)) && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#analize"><em className="icon ni ni-list-round"></em><span>دستمزد</span></a>
								</li>}
								{this.state.data.record.type === 2 && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#additions"><em className="icon ni ni-list-round"></em><span>عوامل افزاینده</span></a>
								</li>}
								{this.state.data.record.type === 2 && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#deductions"><em className="icon ni ni-list-round"></em><span>عوامل کاهنده</span></a>
								</li>}
								{((this.state.data.global.company.mainBussinessType === 3 && this.state.data.record.status !== 0 && this.state.data.record.type === 3 ) || this.state.data.record.type === 5 || (this.state.data.record.type === 6 && this.state.data.record.status === 0)) && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#costs"><em className="icon ni ni-list-round"></em><span>هزینه های مستقیم</span></a>
								</li>}
								{(this.state.data.record.type === 5 || (this.state.data.record.type === 6 && this.state.data.record.status === 0 && this.state.data.global.company.mainBussinessType !== 3)) && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#costs2"><em className="icon ni ni-list-round"></em><span>خدمات برون سپاری</span></a>
								</li>}
								{(this.state.data.record.type === 5 || (this.state.data.record.type === 6 && this.state.data.record.status === 0) || (this.state.data.record.type === 7 && this.state.data.record.status !== 0)) && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#sarbar"><em className="icon ni ni-list-round"></em><span>سربار تولید</span></a>
								</li>}
								{(this.state.data.record.type === 5 || (this.state.data.record.type === 6 && this.state.data.record.status === 0) || (this.state.data.record.type === 7 && this.state.data.record.status !== 0)) && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#dastmozd"><em className="icon ni ni-list-round"></em><span>دستمزد تولید</span></a>
								</li>}
								{this.state.data.record.id !== this.defaultGuid() && ((this.state.data.record.type === 6 && this.state.data.record.status === 0)) && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#remittance_out">
										<span>درخواستهای مواد</span>
									</a></li>}
								{this.state.data.record.id !== this.defaultGuid() && ((this.state.data.record.type === 6 && this.state.data.record.status === 0) || (this.state.data.record.type === 7 && this.state.data.record.status === 1)) && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#remittance_in">
										<span>رسید محصولات</span>
									</a></li>}
								{this.state.data.record.id !== this.defaultGuid() && (this.state.data.record.type === 6 && this.state.data.record.status === 0) && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#wast">
										<span>ضایعات</span>
									</a></li>}
								{this.state.data.record.id !== this.defaultGuid() && (this.state.data.record.type === 6 && this.state.data.record.status === 0) && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#documents">
										<span>اسناد مالی</span>
									</a></li>}
								{this.state.data.record.id !== this.defaultGuid() && (this.state.data.record.type === 6 && this.state.data.record.status === 0) && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#timesheets">
										<span>تایم شیتها</span>
									</a></li>}
								{this.state.data.global.company.mainBussinessType !== 3 && (this.state.data.record.type === 3 && this.state.data.record.status === 1) && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#process">
										<span>پردازش تولید</span>
									</a></li>}
								{(this.state.data.record.type === 7 && this.state.data.record.status !== 0) && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#formualItem1">
										<span>اقلام مصرفی</span>
									</a></li>}
								{(this.state.data.record.type === 7 && this.state.data.record.status !== 0) && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#formualItem2">
										<span>ضایعات برگشت پذیر</span>
									</a></li>}
								{(this.state.data.record.type === 7 && this.state.data.record.status !== 0) && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#formualItem3">
										<span>ضایعات برگشت ناپذیر</span>
									</a></li>}
								{this.showCommerceItems() && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#buyforignfactor">فاکتورهای خرید خارجی</a>
								</li>}
								{this.showCommerceItems() && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#commerceTab0">بارنامه ها</a>
								</li>}
								{this.showCommerceItems() && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#commerceTab1">ترخیصات</a>
								</li>}
								{this.showCommerceItems() && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#commerceTab2">بیمه نامه ها</a>
								</li>}
								{this.showCommerceItems() && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#commerceTab3">فاکتورهای خدمات</a>
								</li>}
								{this.showCommerceItems() && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#commerceTab4">بهای تمام شده</a>
								</li>}

								{this.state.data.record.id !== this.getDefaultGuid() && <li className="nav-item">
									<a className="nav-link" data-bs-toggle="tab" href="#workflow"><span>گردش کار</span></a>
								</li>}
							</ul>}
							{((this.state.data.record.status !== 0 && this.state.data.record.type === 3) || this.state.data.record.type !== 3) && <div className="tab-content">
								<div className="tab-pane active" id="base">
									{this.state.data.record.type !== 6 && this.state.data.record.type !== 3 && this.state.data.record.type !== 7 &&  <table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td style={{ "width": "30px" }}>#</td>
												<td>آیتم<span className="red">*</span></td>
												{this.state.data.record.type === 1 && this.state.data.global.company.mainBussinessType !== 3 && <td>انبار کالا<span className="red">*</span></td>}
												{this.state.data.record.type === 1 && this.state.data.global.company.mainBussinessType !== 3 && <td>خط تولید<span className="red">*</span></td>}
												<td>شرح</td>
												<td style={{ "width": "80px" }}>
													<span>تعداد/مقدار<span className="red">*</span></span>
												</td>
												<td>واحد اصلی<span className="red">*</span></td>
												{this.state.data.global.company.stuffSubUnitEnable === 2 && <td style={{ "width": "80px" }}>
													<span>تعداد/مقدار فرعی</span>
												</td>}
												{this.state.data.global.company.stuffSubUnitEnable === 2 && <td>واحد فرعی</td>}
												{(this.state.data.record.type === 5 || this.state.data.record.type === 2 || this.state.data.record.type === 1) && <td style={{ "width": "100px" }}>مبلغ واحد <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span><span className="red">*</span></td>}
												{this.state.data.record.type === 2 && <td style={{ "width": "85px" }}>تخفیف</td>}
												{this.state.data.record.type === 2 && <td style={{ "width": "120px" }}>مبلغ بعد از تخفیف</td>}
												{this.state.data.record.type === 2 && this.state.data.global.company.enableTaxInProformaInvoice && <td style={{ "width": "90px" }}>مالیات</td>}
												{(this.state.data.record.type === 5 || this.state.data.record.type === 2) && <td style={{ "width": "100px" }}>جمع کل <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></td>}
												<td style={{ "width": "35px" }}></td>
											</tr>
										</thead>
										<tbody>
											{this.state.data.record.items.sort((a, b) => a.order - b.order).map((item, index) =>
												<tr key={item.id}>
													<td>
														<span className="inGridRowNumber">{(index + 1)}</span>
														<div style={{ "font-size": "9pt", "color": "silver" }}>
															{index > 0 && index != this.state.data.record.items.length - 1 && <span onClick={e => this.upIndex(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
															{index < this.state.data.record.items.length - 2 && <span onClick={e => this.downIndex(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
														</div>
													</td>
													<td>
														<SelectAsync
															defaultValue={item.stuffId != this.defaultGuid() ? [{ value: item.stuffId, label: item.stuffName }] : null}
															isMulti={false}
															placeholder="انتخاب"
															noOptionsMessage={({ inputValue }) =>
																inputValue ? "نتیجه‌ای یافت نشد" : null
															}
															defaultOptions={[]}
															components={{
																DropdownIndicator: () => null,
																IndicatorSeparator: () => null,
															}}
															loadOptions={this.loadStuffsOptions}
															onChange={e => this.setBodyValue(item.id, 'stuffId', e)}
														/>
													</td>
													{this.state.data.record.type === 1 && this.state.data.global.company.mainBussinessType !== 3 && <td>
														{item.stuffType !== 2 && <SelectAsync
															defaultValue={item.warehouseId != this.defaultGuid() ? [{ value: item.warehouseId, label: item.warehouseName }] : null}
															isMulti={false}
															placeholder="انتخاب"
															noOptionsMessage={({ inputValue }) =>
																inputValue ? "نتیجه‌ای یافت نشد" : null
															}
															defaultOptions={[]}
															components={{
																DropdownIndicator: () => null,
																IndicatorSeparator: () => null,
															}}
															loadOptions={this.loadWarehousesOptions}
															onChange={e => this.setBodyValue(item.id, 'warehouseId', e)}
														/>}
													</td>}
													{this.state.data.record.type === 1 && this.state.data.global.company.mainBussinessType !== 3 && <td>
														<SelectAsync
															defaultValue={item.productionLineId != this.defaultGuid() ? [{ value: item.productionLineId, label: item.productionLineName }] : null}
															isMulti={false}
															placeholder="انتخاب"
															noOptionsMessage={({ inputValue }) =>
																inputValue ? "نتیجه‌ای یافت نشد" : null
															}
															defaultOptions={[]}
															components={{
																DropdownIndicator: () => null,
																IndicatorSeparator: () => null,
															}}
															loadOptions={this.loadProductionLinesOptions}
															onChange={e => this.setBodyValue(item.id, 'productionLineId', e)}
														/>
													</td>}
													<td>
														<input type="text" className="form-control text-center" defaultValue={item.description} onChange={e => this.setBodyValue(item.id, 'description', e.target.value)} />
													</td>
													<td>
														<NumberFormat value={item.count} onChange={e => this.setBodyValue(item.id, 'count', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
													</td>
													<td>{item.unitName}</td>
													{this.state.data.global.company.stuffSubUnitEnable === 2 &&
														<td>
															<span className="onlyMobile">تعداد/مقدار فرعی: </span>
															<NumberFormat value={item.modulusCount} onChange={e => this.setBodyValue(item.id, 'modulusCount', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
														</td>}
													{this.state.data.global.company.stuffSubUnitEnable === 2 && <td>{item.modulusUnitName}</td>}
													{(this.state.data.record.type === 5 || this.state.data.record.type === 2 || this.state.data.record.type === 1) && <td><NumberFormat value={item.price} onChange={e => this.setBodyValue(item.id, 'price', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>}
													{this.state.data.record.type === 2 && <td><NumberFormat value={item.discount} onChange={e => this.setBodyValue(item.id, 'discount', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>}
													{this.state.data.record.type === 2 && <td><NumberFormat readOnly={true} value={item.adis} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>}
													{this.state.data.record.type === 2 && this.state.data.global.company.enableTaxInProformaInvoice && <td><NumberFormat readOnly={true} value={item.tax} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>}
													{(this.state.data.record.type === 5 || this.state.data.record.type === 2) && <td>
														<NumberFormat readOnly={true} value={item.total} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
													</td>}
													<td>
														{item.stuffId != this.defaultGuid() && <span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>}
														{item.stuffId != this.defaultGuid() && <span title="کپی سطر" onClick={e => this.copyRow(item.id)} className="fa fa-copy fa-fw close-grid-row"></span>}
													</td>
												</tr>
											)}
										</tbody>
									</table>}
									{(this.state.data.record.type === 6 || this.state.data.record.type === 3) && <table className="table table-bordered acc_grid_row" key={this.state.baseVersion}>
										<thead>
											<tr className="active">
												<td style={{ "width": "30px" }}>#</td>
												<td>آیتم</td>
												<td>شرح</td>
												<td style={{ "width": "80px" }}>تعداد/مقدار</td>
												<td>واحد اصلی</td>
												{this.state.data.global.company.stuffSubUnitEnable === 2 && <td style={{ "width": "80px" }}>تعداد/مقدار فرعی</td>}
												{this.state.data.global.company.stuffSubUnitEnable === 2 && <td>واحد فرعی</td>}
												{this.state.data.global.company.mainBussinessType === 3 && <td></td> }
											</tr>
										</thead>
										{this.state.data.global.company.mainBussinessType !== 3 && <tbody>
											{this.state.data.record.items.sort((a, b) => a.order - b.order).map((item, index) =>
												<tr key={item.id}>
													<td>
														<span className="inGridRowNumber">{(index + 1)}</span>
													</td>
													<td>{item.stuffName}</td>
													<td>
														<input type="text" className="form-control text-center" defaultValue={item.description} onChange={e => this.setBodyValue(item.id, 'description', e.target.value)} />
													</td>
													<td>{(item.count * this.getProductionAmount())}</td>
													<td>{item.unitName}</td>
													{this.state.data.global.company.stuffSubUnitEnable === 2 && <td>{item.modulusCount * this.getProductionAmount()}</td>}
													{this.state.data.global.company.stuffSubUnitEnable === 2 && <td>{item.modulusUnitName}</td>}
												</tr>
											)}
										</tbody>}
										{this.state.data.global.company.mainBussinessType === 3 && <tbody>
											{this.state.data.record.items.sort((a, b) => a.order - b.order).map((item, index) =>
												<tr key={item.id}>
													<td>
														<span className="inGridRowNumber">{(index + 1)}</span>
														<div style={{ "font-size": "9pt", "color": "silver" }}>
															{index > 0 && index != this.state.data.record.items.length - 1 && <span onClick={e => this.upIndex(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
															{index < this.state.data.record.items.length - 2 && <span onClick={e => this.downIndex(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
														</div>
													</td>
													<td>
														<SelectAsync
															defaultValue={item.stuffId != this.defaultGuid() ? [{ value: item.stuffId, label: item.stuffName }] : null}
															isMulti={false}
															placeholder="انتخاب"
															noOptionsMessage={({ inputValue }) =>
																inputValue ? "نتیجه‌ای یافت نشد" : null
															}
															defaultOptions={[]}
															components={{
																DropdownIndicator: () => null,
																IndicatorSeparator: () => null,
															}}
															loadOptions={this.loadStuffsOptions}
															onChange={e => this.setBodyValue(item.id, 'stuffId', e)}
														/>
													</td>
													<td>
														<input type="text" className="form-control text-center" defaultValue={item.description} onChange={e => this.setBodyValue(item.id, 'description', e.target.value)} />
													</td>
													<td>
														<NumberFormat value={item.count} onChange={e => this.setBodyValue(item.id, 'count', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
													</td>
													<td>{item.unitName}</td>
													{this.state.data.global.company.stuffSubUnitEnable === 2 &&
														<td>
															<span className="onlyMobile">تعداد/مقدار فرعی: </span>
															<NumberFormat value={item.modulusCount} onChange={e => this.setBodyValue(item.id, 'modulusCount', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
														</td>}
													{this.state.data.global.company.stuffSubUnitEnable === 2 && <td>{item.modulusUnitName}</td>}
													<td>
														{item.stuffId != this.defaultGuid() && <span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>}
														{item.stuffId != this.defaultGuid() && <span title="کپی سطر" onClick={e => this.copyRow(item.id)} className="fa fa-copy fa-fw close-grid-row"></span>}
													</td>
												</tr>
											)}
										</tbody>}
									</table>}
									{this.state.data.record.type === 7 && <table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td style={{ "width": "30px" }}>#</td>
												<td>محصول<span className="red">*</span></td>
												<td>خط تولید<span className="red">*</span></td>
												<td>توضیحات</td>
												<td style={{ "width": "80px" }}><span>تعداد/مقدار<span className="red">*</span></span></td>
												<td>واحد اصلی<span className="red">*</span></td>
												{this.state.data.global.company.stuffSubUnitEnable === 2 && <td style={{ "width": "80px" }}><span>تعداد/مقدار فرعی</span></td>}
												{this.state.data.global.company.stuffSubUnitEnable === 2 && <td>واحد فرعی</td>}
												<td style={{ "width": "35px" }}></td>
											</tr>
										</thead>
										<tbody>
											{this.state.data.record.items.sort((a, b) => a.order - b.order).map((item, index) =>
												<tr key={item.id}>
													<td>
														<span className="inGridRowNumber">{(index + 1)}</span>
														{this.state.data.record.status === 0 && <div style={{ "font-size": "9pt", "color": "silver" }}>
															{index > 0 && index != this.state.data.record.items.length - 1 && <span onClick={e => this.upIndex(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
															{index < this.state.data.record.items.length - 2 && <span onClick={e => this.downIndex(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
														</div>}
													</td>
													<td>
														{this.state.data.record.status === 0 ? <SelectAsync
															defaultValue={item.stuffId != this.defaultGuid() ? [{ value: item.stuffId, label: item.stuffName }] : null}
															isMulti={false}
															placeholder="انتخاب"
															noOptionsMessage={({ inputValue }) =>
																inputValue ? "نتیجه‌ای یافت نشد" : null
															}
															defaultOptions={[]}
															components={{
																DropdownIndicator: () => null,
																IndicatorSeparator: () => null,
															}}
															loadOptions={this.loadStuffsOptions}
															onChange={e => this.setBodyValue(item.id, 'stuffId', e)}
														/>
															:
															<span>{item.stuffName}</span>
														}
													</td>
													<td>
														{this.state.data.record.status === 0 ? <SelectAsync
															defaultValue={item.productionLineId != this.defaultGuid() ? [{ value: item.productionLineId, label: item.productionLineName }] : null}
															isMulti={false}
															placeholder="انتخاب"
															noOptionsMessage={({ inputValue }) =>
																inputValue ? "نتیجه‌ای یافت نشد" : null
															}
															defaultOptions={[]}
															components={{
																DropdownIndicator: () => null,
																IndicatorSeparator: () => null,
															}}
															loadOptions={this.loadProductionLinesOptions}
															onChange={e => this.setBodyValue(item.id, 'productionLineId', e)}
														/>
															:
															<span>{item.productionLineName}</span>
														}
													</td>
													<td>
														{this.state.data.record.status === 0 ?
															<input type="text" className="form-control text-center" defaultValue={item.description} onChange={e => this.setBodyValue(item.id, 'description', e.target.value)} />
															:
															<span>{item.description}</span>
														}
													</td>
													<td>
														{this.state.data.record.status === 0 ?
															<NumberFormat value={item.count} onChange={e => this.setBodyValue(item.id, 'count', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
														:
														<span>{item.count}</span>
														}
													</td>
													<td>{item.unitName}</td>
													{this.state.data.global.company.stuffSubUnitEnable === 2 &&
														<td>
															{this.state.data.record.status === 0 ?
															<NumberFormat value={item.modulusCount} onChange={e => this.setBodyValue(item.id, 'modulusCount', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
															:
															<span>{item.modulusCount}</span>
															}
														</td>}
													{this.state.data.global.company.stuffSubUnitEnable === 2 && <td>{item.modulusUnitName}</td>}
													{this.state.data.record.status === 0 && <td>
														{item.stuffId != this.defaultGuid() && <span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>}
														{item.stuffId != this.defaultGuid() && <span title="کپی سطر" onClick={e => this.copyRow(item.id)} className="fa fa-copy fa-fw close-grid-row"></span>}
													</td>}
												</tr>
											)}
										</tbody>
									</table>}
								</div>
								<div className="tab-pane" id="costs">
									<table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td style={{ "width": "30px" }}>#</td>
												<td>آیتم</td>
												<td>شرح</td>
												<td style={{ "width": "95px" }}>تاریخ</td>
												<td style={{ "width": "80px" }}>
													<span>تعداد مبنا<span className="red">*</span></span>
												</td>
												<td style={{ "width": "100px" }}>مبلغ مبنا <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span><span className="red">*</span></td>
												<td style={{ "width": "100px" }}>جمع کل <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></td>

												<td style={{ "width": "35px" }}></td>
											</tr>
										</thead>
										<tbody>
											{this.state.data.record.costs.filter(f => f.type === 0).sort((a, b) => a.order - b.order).map((item, index) =>
												<tr key={item.id}>
													<td>
														<span className="inGridRowNumber">{(index + 1)}</span>
													</td>
													<td>
														<SelectAsync
															defaultValue={item.stuffId != this.defaultGuid() ? [{ value: item.stuffId, label: item.stuffName }] : null}
															isMulti={false}
															placeholder="انتخاب"
															noOptionsMessage={({ inputValue }) =>
																inputValue ? "نتیجه‌ای یافت نشد" : null
															}
															defaultOptions={[]}
															components={{
																DropdownIndicator: () => null,
																IndicatorSeparator: () => null,
															}}
															loadOptions={this.loadStuffsOptions}
															onChange={e => this.setCostValue(item.id, 'stuffId', e)}
														/>
													</td>
													<td>
														<input type="text" className="form-control text-center" defaultValue={item.description} onChange={e => this.setCostValue(item.id, 'description', e.target.value)} />
													</td>
													<td style={{ "width": "80px" }}>
														<DatePicker
															inputReadOnly={true}
															className="form-control persian-date"
															placeholder={"تاریخ"}
															isGregorian={false}
															showTodayButton={true}
															timePicker={false}
															onChange={(e) => { this.setCostValue(item.id, 'date', e) }}
															value={this.getFormatedDateForDatePicker(item.date)}
														/>
													</td>
													<td>
														<NumberFormat value={item.count} onChange={e => this.setCostValue(item.id, 'count', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
													</td>
													<td><NumberFormat value={item.price} onChange={e => this.setCostValue(item.id, 'price', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>
													<td>
														<NumberFormat readOnly={true} value={item.total} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
													</td>
													<td>
														<span title="حذف سطر" onClick={e => this.removeCostRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
													</td>
												</tr>
											)}
										</tbody>
									</table>
									<a onClick={e => this.addBlankCostRow(0)} className="hand btn btn-primary">افزودن هزینه جدید</a>
								</div>
								<div className="tab-pane" id="costs2">
									<table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td style={{ "width": "30px" }}>#</td>
												<td>آیتم</td>
												<td>شرح</td>
												<td style={{ "width": "95px" }}>تاریخ</td>
												<td style={{ "width": "80px" }}>
													<span>تعداد مبنا<span className="red">*</span></span>
												</td>
												<td style={{ "width": "100px" }}>مبلغ مبنا <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span><span className="red">*</span></td>
												<td style={{ "width": "100px" }}>جمع کل <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></td>

												<td style={{ "width": "35px" }}></td>
											</tr>
										</thead>
										<tbody>
											{this.state.data.record.costs.filter(f => f.type === 1).sort((a, b) => a.order - b.order).map((item, index) =>
												<tr key={item.id}>
													<td>
														<span className="inGridRowNumber">{(index + 1)}</span>
													</td>
													<td>
														<SelectAsync
															defaultValue={item.stuffId != this.defaultGuid() ? [{ value: item.stuffId, label: item.stuffName }] : null}
															isMulti={false}
															placeholder="انتخاب"
															noOptionsMessage={({ inputValue }) =>
																inputValue ? "نتیجه‌ای یافت نشد" : null
															}
															defaultOptions={[]}
															components={{
																DropdownIndicator: () => null,
																IndicatorSeparator: () => null,
															}}
															loadOptions={(inputValue, callback) => this.loadStuffsOptions(inputValue, callback, 2)}
															onChange={e => this.setCostValue(item.id, 'stuffId', e)}
														/>
													</td>
													<td>
														<input type="text" className="form-control text-center" defaultValue={item.description} onChange={e => this.setCostValue(item.id, 'description', e.target.value)} />
													</td>
													<td style={{ "width": "80px" }}>
														<DatePicker
															inputReadOnly={true}
															className="form-control persian-date"
															placeholder={"تاریخ"}
															isGregorian={false}
															showTodayButton={true}
															timePicker={false}
															onChange={(e) => { this.setCostValue(item.id, 'date', e) }}
															value={this.getFormatedDateForDatePicker(item.date)}
														/>
													</td>
													<td>
														<NumberFormat value={item.count} onChange={e => this.setCostValue(item.id, 'count', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
													</td>
													<td><NumberFormat value={item.price} onChange={e => this.setCostValue(item.id, 'price', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>
													<td>
														<NumberFormat readOnly={true} value={item.total} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
													</td>
													<td>
														<span title="حذف سطر" onClick={e => this.removeCostRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
													</td>
												</tr>
											)}
										</tbody>
									</table>
									<a onClick={e => this.addBlankCostRow(1)} className="hand btn btn-primary">افزودن آیتم جدید</a>
								</div>
								<div className="tab-pane" id="sarbar">
									<div className="row">
										<div className="col-sm-2">
											<div className="form-group">
												<label className="title1">عدد مبنای سربار</label>
												<div>
													<NumberFormat value={this.state.data.record.overheadBase} onChange={e => this.setOverheadBase(e)} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
												</div>
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label className="title1">نرخ جذب سربار</label>
												<div>
													<NumberFormat value={this.state.data.record.overheadRate} onChange={e => this.setOverheadRate(e)} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
												</div>
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label className="title1">سربار برآوردی</label>
												<div>
													<NumberFormat value={this.state.data.record.estimatedOverhead} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="tab-pane" id="dastmozd">
									<div className="row">
										<div className="col-sm-2">
											<div className="form-group">
												<label className="title1">عدد مبنای دستمزد</label>
												<div>
													<NumberFormat value={this.state.data.record.salaryBase} onChange={e => this.setSalaryBase(e)} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
												</div>
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label className="title1">نرخ جذب دستمزد</label>
												<div>
													<NumberFormat value={this.state.data.record.salaryRate} onChange={e => this.setSalaryRate(e)} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
												</div>
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label className="title1">دستمزد برآوردی</label>
												<div>
													<NumberFormat value={this.state.data.record.estimatedSalary} readOnly={true} thousandSeparator={true} prefix={''} className='form-control text-center ltr' />
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="tab-pane" id="analize" role="tabpanel">
									{this.renderAnalize()}
								</div>

								<div className="tab-pane" id="additions" role="tabpanel">
									{this.renderAdjustments(1)}
								</div>
								<div className="tab-pane" id="deductions" role="tabpanel">
									{this.renderAdjustments(2)}
								</div>

								{this.state.data.record.id !== this.defaultGuid() && ((this.state.data.record.type === 6 && this.state.data.record.status === 0)) && <div className="tab-pane" id="remittance_out" role="tabpanel">
									<Remittances OrderingId={this.state.data.record.id} IO={2} Inline={true} CurrentAnnual={false} />
								</div>}
								{this.state.data.record.id !== this.defaultGuid() && ((this.state.data.record.type === 6 && this.state.data.record.status === 0) || (this.state.data.record.type === 7 && this.state.data.record.status === 1)) && <div className="tab-pane" id="remittance_in" role="tabpanel">
									<Remittances OrderingId={this.state.data.record.id} IO={1} Inline={true} CurrentAnnual={false} />
								</div>}
								{this.state.data.record.id !== this.defaultGuid() && (this.state.data.record.type === 6 && this.state.data.record.status === 0) && <div className="tab-pane" id="wast" role="tabpanel">
									<Factors OrderingId={this.state.data.record.id} Type={5} Inline={true} CurrentAnnual={false} />
								</div>}
								{this.state.data.record.id !== this.defaultGuid() && (this.state.data.record.type === 6 && this.state.data.record.status === 0) && <div className="tab-pane" id="documents" role="tabpanel">
									<Documents OrderingId={this.state.data.record.id} Inline={true} CurrentAnnual={false} />
								</div>}
								{this.state.data.record.id !== this.defaultGuid() && (this.state.data.record.type === 6 && this.state.data.record.status === 0) && <div className="tab-pane" id="timesheets" role="tabpanel">
									<TimeSheetHeaders OrderingId={this.state.data.record.id} InitType={4} Inline={true} />
								</div>}
								{this.state.data.global.company.mainBussinessType !== 3 && (this.state.data.record.type === 3 && this.state.data.record.status === 1) && <div className="tab-pane" id="process" role="tabpanel">
									<Orderings Department={''} ParentId={this.state.data.record.id} Type={6} Inline={true} />
								</div>}

								{(this.state.data.record.type === 7 && this.state.data.record.status !== 0) && <div className="tab-pane" id="formualItem1" role="tabpanel">
									{this.renderForumalItems(0)}
								</div>}
								{(this.state.data.record.type === 7 && this.state.data.record.status !== 0) && <div className="tab-pane" id="formualItem2" role="tabpanel">
									{this.renderForumalItems(1)}
								</div>}
								{(this.state.data.record.type === 7 && this.state.data.record.status !== 0) && <div className="tab-pane" id="formualItem3" role="tabpanel">
									{this.renderForumalItems(2)}
								</div>}

								{this.showCommerceItems() && <div className="tab-pane" id="buyforignfactor">
									<Factors Inline={true} Type={6} OrderingId={this.state.data.record.id} />
								</div>}
								{this.showCommerceItems() && <div className="tab-pane" id="commerceTab0">
									<BillOfLadings Inline={true} OrderingId={this.state.data.record.id} />
								</div>}
								{this.showCommerceItems() && <div className="tab-pane" id="commerceTab1">
									<CustomsClearances Inline={true} OrderingId={this.state.data.record.id} />
								</div>}
								{this.showCommerceItems() && <div className="tab-pane" id="commerceTab2">
									<InsurancePolicies Inline={true} OrderingId={this.state.data.record.id} />
								</div>}
								{this.showCommerceItems() && <div className="tab-pane" id="commerceTab3">
									<Factors Inline={true} Type={7} OrderingId={this.state.data.record.id} />
								</div>}
								{this.showCommerceItems() && <div className="tab-pane" id="commerceTab4">
									<FullPrices Inline={true} OrderingId={this.state.data.record.id} />
								</div>}

								{this.state.data.record.id !== this.getDefaultGuid() && <div className="tab-pane" id="workflow">
									<WorkFlowStepLogging Caller={this} EntityId={this.state.data.record.id} WorkFlowStepId={this.state.data.record.workFlowStepId} Type={5} />
								</div>}
							</div>}

							{this.state.data.record.type === 2 && <div className="row" style={{ "padding-left": "15px" }} >
								<div className="col-lg-9 col-md-12 col-sm-12">
								</div>
								<div className="col-lg-3 col-md-12 col-sm-12" style={{ "padding": "0" }} >
									<div className="row text-left">
										<div className="col-lg-6 title1" style={{ "padding": "0" }} >مجموع <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></div>
										<div className="col-lg-6 text-center title1" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.tprdis)}</div>
									</div>
									<div className="row text-left">
										<div className="col-lg-6 title1" style={{ "padding": "0" }} >مجموع تخفیفات <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></div>
										<div className="col-lg-6 text-center title1 red" style={{ "direction": "ltr" }} >({this.money(this.state.data.record.tdis)})</div>
									</div>
									{(this.state.enableTaxInProformaInvoice || this.state.data.record.type !== 2) && <div className="row text-left">
										<div className="col-lg-6 title1" style={{ "padding": "0" }} >جمع مالیات<span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></div>
										<div className="col-lg-6 text-center title1" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.tvam)}</div>
									</div>}

									<div className="row text-left">
										<div className="col-lg-6 title1" style={{ "padding": "0" }} >مجموع عوامل افزاینده </div>
										<div className="col-lg-6 text-center title1 red" style={{ "direction": "ltr" }} >{this.money(this.getAdjustmentSum(1))}</div>
									</div>
									<div className="row text-left">
										<div className="col-lg-6 title1" style={{ "padding": "0" }} >مجموع عوامل کاهنده </div>
										<div className="col-lg-6 text-center title1 red" style={{ "direction": "ltr" }} >({this.money(this.getAdjustmentSum(2))})</div>
									</div>
									<div className="row" style={{ "border-top": "1px solid rgb(69, 69, 69)", "margin-top": "1px", "margin-bottom": "1px" }} ></div>
									<div className="row text-left" style={{ "border-bottom": "1px solid rgb(69, 69, 69)" }} >
										<div className="col-lg-6 h5 txt-bold" style={{ "padding": "0" }}>مبلغ نهایی<span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></div>
										<div className="col-lg-6 h5 text-center txt-bold" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.total)}</div>
									</div>
									<div className="row" style={{ "border-top": "1px solid rgb(69, 69, 69)", "margin-top": "1px", "margin-bottom": "10px" }} ></div>
								</div>
							</div>
							}
							{this.state.data.record.status === 1 && <div className="row" style={{ "padding-left": "15px" }} >
								<div className="col-lg-12 col-md-12 col-sm-12">
									<div className="form-group">
										{this.state.data.record.type !== 3 && <label className="title1" for="comment">توضیحات (در صورت عدم تایید)</label>}
										{this.state.data.record.type === 3 && <label className="title1" for="comment">توضیحات (در صورت لغو تولید)</label>}
										<textarea onChange={e => this.state.data.record.rejectDescription = e.target.value} defaultValue={this.state.data.record.note} className="form-control" rows="2" maxlength="400"></textarea>
									</div>
								</div>
							</div>}

						</div>
						<div className="modal-footer">
							{((this.state.data.record.type === 7 && this.state.data.record.status === 1) || (this.state.data.record.type === 3 && this.state.data.record.status === 1)) &&
								<button type="button" className="hand btn btn-primary" onClick={e => this.save(e, 1)}>ذخیره</button>
							}
							{this.state.data.record.status === 0 && <button type="button" className="hand btn btn-primary" onClick={e => this.save(e, 0)} >ذخیره</button>}
							{this.state.data.record.status === 0 && this.state.data.record.type === 7 && <button type="button" className="hand btn btn-success" onClick={e => this.save(e, 1)} >شروع تولید</button>}

							{(this.state.data.record.type !== 7 && this.state.data.record.type !== 3 && this.state.data.record.status === 1) &&
								<button type="button" className="hand btn btn-success" onClick={e => this.save(e, 2)}>تایید</button>
							}
							{((this.state.data.record.type === 7 || this.state.data.record.type === 3) && this.state.data.record.status === 1) &&
								<button type="button" className="hand btn btn-success" onClick={e => this.save(e, 2)}>تکمیل تولید</button>
							}

							{(this.state.data.record.type !== 3 && this.state.data.record.status === 1) &&
								<button type="button" className="hand btn btn-warning" onClick={e => this.save(e, 3)}>رد</button>
							}
							{this.state.data.record.type === 1 && (this.state.data.record.status === 0 || this.state.data.record.status === 3) &&
								<button type="button" className="hand btn btn-success" onClick={e => this.save(e, 1)}>{this.T('btn.sendToWarehouse')}</button>
							}
							{(this.state.data.record.type === 3 && this.state.data.record.status === 0) &&
								<button type="button" className="hand btn btn-success" onClick={e => this.save(e, 6)}>ارسال به برنامه ریزی</button>
							}
							{(this.state.data.record.type === 3 && this.state.data.record.status === 6) &&
								<button type="button" className="hand btn btn-warning" onClick={e => this.save(e, 0)}>ارجاع به قبل</button>
							}
							{(this.state.data.record.type === 3 && this.state.data.record.status === 6) &&
								<button type="button" className="hand btn btn-success" onClick={e => this.save(e, 1)}>شروع تولید</button>
							}
							{((this.state.data.record.type === 2 && this.state.data.record.status === 0) || (this.state.data.record.type === 1 && this.state.data.record.status === 2)) &&
								<button type="button" className="hand btn btn-success" onClick={e => this.save(e, 4)}>صدور فاکتور</button>
							}
							{this.state.data.record.id !== this.defaultGuid() && <a onClick={e => this.getPdf(this.state.data.record.id)} className="btn btn-danger"><span>PDF</span></a>}

							{((this.state.data.record.type === 7 && this.state.data.record.status === 1) || (this.state.data.record.type === 3 && this.state.data.record.status === 1)) &&
								<button type="button" className="hand btn btn-warning" onClick={e => this.save(e, 3)}>لغو</button>
							}
							<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}